import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Tampura = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/sushi' name='Темпури'/>
            <main className={s.main}>
                <Product name='Темпура рол з лососем' price='210 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, лосось, огірок, кляр, пластівці кукурудзяні'/>
                <Product name='Темпура рол з вугрем' price='230 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, вугор, огірок, кляр, пластівці кукурудзяні'/>
                <Product name='Темпура рол з креветкою' price='210 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, креветка, огірок, кляр, пластівці кукурудзяні'/>
                <Product name='Темпура рол з крабовою паличкою' price='180 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, крабова паличка, огірок, кляр, пластівці кукурудзяні'/>
                <Product name='Темпура рол з Цезар' price='170 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, бедро, полідор, листя салату, пармезан, соус "Цезар", огірок, кляр, пластівці кукурудзяні'/>
            </main>
        </div>
    )
}

export default Tampura;